import {BaseContainerModel} from '../base-container.model';
import {app_cfg_main_RowClass} from '../../dbschema/app_cfg_main.model';
import {app_cfg_main_ext_RowClass} from '../../dbschema/app_cfg_main_ext.model';

export class AppCfgMainContainerModel extends BaseContainerModel {
  appCfgMain: app_cfg_main_RowClass = new app_cfg_main_RowClass();
  appCfgMainExtList: app_cfg_main_ext_RowClass[] = [];
}
